import { PinCodeAuthenticationFeedbackLabel } from '@screens/review-section3/pincode-authorisation/feedback-label';
import ResendCodeLabel from '@screens/review-section3/pincode-authorisation/resend-code-label';
import { SecondaryButton } from '@screens/review-section3/pincode-authorisation/styles';
import { getPinCodeFormTranslations } from '@screens/review-section3/pincode-authorisation/translations';
import {
    createAuthenticationStore,
    createLoaderService
} from '@services/factories';
import { ILoaderService } from '@services/LoaderService';
import { StringFormatService } from '@services/StringFormatService';
import { authenticationParamsContext } from '@stores/authentication/authentication-params-context';
import { IAuthenticationStore } from '@stores/authentication/authentication-store';
import { IPinCodeStore } from '@stores/authorisation/pin-code-store';
import { observer } from 'mobx-react';
import * as React from 'react';
import {
    PinCodeButtonStack,
    PinCodeField,
    PinCodeFormContainer,
    PinCodeFormLayout,
    PrimaryButton
} from './pin-code-form-styles';

interface Props {
    pinCodeStore: IPinCodeStore;
    onSendPinCode?: () => void;
    onAuthenticationSuccess?: () => void;
    onAuthenticationFailure?: () => void;
}

@observer
export class PinCodeForm extends React.Component<Props> {
    static contextType = authenticationParamsContext;
    declare context: React.ContextType<typeof authenticationParamsContext>;

    // Probably good idea to dependency inject these later
    loaderService: ILoaderService = createLoaderService();
    authenticationStore: IAuthenticationStore = createAuthenticationStore();

    translations = getPinCodeFormTranslations();

    handlePinCodeInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.props.pinCodeStore.editPinCodeInput(event.target.value);
    };

    handleSubmitPinCode = async (event: React.SyntheticEvent) => {
        event.preventDefault();

        this.loaderService.showLoader();

        await this.authenticationStore.authenticatePinCode(
            this.context!.params,
            this.props.pinCodeStore.pinCodeInput
        );

        if (this.authenticationStore.didFailAuthentication) {
            this.loaderService.hideLoader();
            this.props.onAuthenticationFailure?.();
            return;
        }

        this.loaderService.hideLoader();
        this.props.onAuthenticationSuccess?.();
    };

    handleResendPinCodeClick = async (event: React.SyntheticEvent) => {
        event.preventDefault();
        this.authenticationStore.resetAuthenticationAttempt();
        this.props.pinCodeStore.editPinCodeInput('');
        this.props.onSendPinCode?.();
    };

    render() {
        const candidateFullName = this.context!.fullName;

        const pinCodeFieldLabel = StringFormatService.format(
            this.translations.pinCodeFormLabelTemplate,
            [candidateFullName]
        );
        return (
            <PinCodeFormLayout innerSpacing='small'>
                <PinCodeFormContainer noValidate={true}
                                      autoComplete='off'
                                      onSubmit={this.handleSubmitPinCode}>
                    <ResendCodeLabel store={this.props.pinCodeStore}
                                     candidateFullName={this.context?.fullName ?? ''}/>
                    <PinCodeField type='text'
                                  autoFocus={true}
                                  value={this.props.pinCodeStore.pinCodeInput}
                                  helperText={(
                                      <PinCodeAuthenticationFeedbackLabel authenticationStore={this.authenticationStore}/>
                                  )}
                                  label={pinCodeFieldLabel}
                                  onChange={this.handlePinCodeInputChange}/>
                    <PinCodeButtonStack innerSpacing='small'>
                        <PrimaryButton onClick={this.handleSubmitPinCode}>
                            {this.translations.submitButton}
                        </PrimaryButton>
                        <SecondaryButton onClick={this.handleResendPinCodeClick}>
                            {this.translations.resendCodeButton}
                        </SecondaryButton>
                    </PinCodeButtonStack>
                </PinCodeFormContainer>
            </PinCodeFormLayout>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/review-section3/pincode-authorisation/pin-code-form.tsx